import {
	CONFIRM_EMAIL,
	CONFIRM_PHONE,
	CONFIRM_PHONE_CODE, CONFIRM_SET_GUEST, GUEST_ORDER_LOGIN_ANONYMOUSLY,
	SELECT_LANGUAGE,
	SET_EMAIL_MARKETING_CONSENT,
	SET_SMS_MARKETING_CONSENT,
	START_EMAIL_EDIT,
} from 'new-constants/customer.constants';
import {SET_EMAIL} from 'new-constants/api.constants';
import {CONFIRM_GUEST_ORDER_POPUP} from "new-constants/popup.constants";

export const confirmPhone = phone => {
	return {
		type: CONFIRM_PHONE,
		phone,
	};
};

export const confirmPhoneCode = (phoneCode, termsConsent, marketingConsent, shouldOpenCartOnLogin) => {
	return {
		type: CONFIRM_PHONE_CODE,
		phoneCode,
		termsConsent,
		marketingConsent,
		shouldOpenCartOnLogin,
	};
};

export const selectLanguage = language => {
	return {
		type: SELECT_LANGUAGE,
		language,
	};
};

export const setEmailMarketingConsent = newEmailMarketingConsent => {
	return {
		type: SET_EMAIL_MARKETING_CONSENT,
		newEmailMarketingConsent,
	};
};

export const setSmsMarketingConsent = newSmsMarketingConsent => {
	return {
		type: SET_SMS_MARKETING_CONSENT,
		newSmsMarketingConsent,
	};
};


export const confirmSetGuest = (name, phone, acceptTerms) => {
	return {
		type: CONFIRM_SET_GUEST,
		name,
		phone,
		acceptTerms
	};
};

export const guestOrderLoginAnonymously = () => {
	return {
		type: GUEST_ORDER_LOGIN_ANONYMOUSLY,
	};
};
